import { render, staticRenderFns } from "./accept.vue?vue&type=template&id=1ae9d0b3&scoped=true"
import script from "./accept.vue?vue&type=script&lang=js"
export * from "./accept.vue?vue&type=script&lang=js"
import style0 from "./accept.vue?vue&type=style&index=0&id=1ae9d0b3&prod&lang=css"
import style1 from "./accept.vue?vue&type=style&index=1&id=1ae9d0b3&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae9d0b3",
  null
  
)

export default component.exports